import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import { Outlet } from 'react-router-dom';

const Layout = styled.div`
    height: 100%;
    width:100%;
    font-family: 'Roboto', sans-serif;
    display: flex;
    flex-direction:column;
`

const Content = styled.div`
    position:relative;
    width:100%;
    overflow-Y:auto;
    height:100%;
`;


const AppLayout = (props) => {
  return (
    <Layout>
      <Header machinePage={false} />
      <Content>
          {props.children};
      </Content>
    </Layout>
  )
}

export default AppLayout;
